module.exports = __webpack_public_path__ + "static/origami-a41b5134c1686209d9b2ecf626f19ebd.gif";